export default {
  COMPANY_TITLE: 'Company',
  COMPANY_TEAM_MEMBERS_LABEL: 'Team Members',
  COMPANY_INVITES_LABEL: 'Invites',
  COMPANY_EDIT_LABEL: 'Edit Org',
  COMPANY_ADD_EMPLOYEE_ID_LABEL: 'Add Employee ID',
  COMPANY_ADD_PHONE_NUMBER_LABEL: 'Add Phone Number',
  COMPANY_ADD_ADDRESS_LABEL: 'Add Address',
  COMPANY_ADD_WEBSITE_LABEL: 'Add Website',
  COMPANY_ADMIN: 'Admin',
  COMPANY_ALL_LABELS: 'All Labels',
  COMPANY_EDIT_PROFILE_LABEL: 'Edit Org Profile',
  COMPANY_FORM_FIX_ERRORS_MESSAGE: 'Fix errors to save the data',
  COMPANY_LABEL_MANAGEMENT: 'Label Management',
  COMPANY_LABEL_MANAGEMENT_DESCRIPTION:
    'View and manage labels used to group and identify your constituents.',
  COMPANY_LABEL_CREATE: 'Create a label',
  COMPANY_NAME_LABEL: 'Company Name',
  COMPANY_EMPLOYEE_ID_LABEL: 'Employee ID Number',
  COMPANY_PHONE_NUMBER_LABEL: 'Phone Number',
  COMPANY_WEBSITE_LABEL: 'Org Website',
  COMPANY_INFO_UPDATED_LABEL: 'Company Info Updated',
  COMPANY_INFO_UPDATED_MESSAGE: 'Company Info was successfully updated',
  COMPANY_TEAM_MEMBER_NAME_LABEL: 'Team Member',
  COMPANY_TEAM_MEMBER_FIRST_NAME_LABEL: 'First',
  COMPANY_TEAM_MEMBER_LAST_NAME_LABEL: 'Last',
  COMPANY_TEAM_MEMBER_LAST_VISIT_LABEL: 'Last Visit',
  COMPANY_TEAM_MEMBER_EMAIL_LABEL: 'Email',
  COMPANY_TEAM_MEMBER_PERMISSIONS_LABEL: 'Permissions',
  COMPANY_TEAM_MEMBER_STATUS_LABEL: 'Status',
  COMPANY_SEARCH_LABEL: 'Find Team Member',
  COMPANY_RESEND_LABEL: 'Resend',
  COMPANY_INVITE_BTN_LABEL: 'Invite Team Member',
  COMPANY_SEND_INVITES_MODAL_DESCRIPTION:
    "Set the permission type and add your teammate's emails below.",
  COMPANY_PAGE_INVITE_TEAM_LABEL: 'Invite your team',
  COMPANY_PAGE_INVITE_TEAM_PLACEHOLDER:
    'Copy and paste or type your teammates emails here.',
  COMPANY_PAGE_PERMISSION_TYPE_LABEL: 'Permission type',
  COMPANY_PAGE_NO_INVITES_LABEL: 'You have no pending invites',
  COMPANY_PAGE_INVITE_SENT_LABEL: 'Invite Sent',
  COMPANY_PAGE_INVITE_SENT_MESSAGE:
    'Have your teammates check their email for the link to join.',
  COMPANY_INVITE_FORM_FIX_EMAILS_MESSAGE: 'Fix emails to send invites',
  COMPANY_INVITE_UPDATE_INVITE_ERROR_MESSAGE:
    'There was a problem updating the invite of {email}',
  COMPANY_INVITE_REMOVE_INVITE_ERROR_MESSAGE:
    'There was a problem removing the invite of {email}',
  COMPANY_INVITE_RESEND_INVITE_ERROR_MESSAGE:
    'There was a problem resending an invite to {email}',
  COMPANY_FUNDRAISING: 'Fundraising',
  COMPANY_FUNDRAISING_INTEGRATION_SETTINGS:
    'New constituents added via your Fundraiser Pages can be automatically added to a Lifecycle Board. Choose a board and column below to apply to all new donors.',
  COMPANY_POWERED_BY_PLEDGE: 'powered by Pledge',
  COMPANY_UPDATE_MEMBER_ERROR_MESSAGE: 'There was a problem updating {name}',
  COMPANY_REMOVE_MEMBER_ERROR_MESSAGE: 'There was a problem removing {name}',
  COMPANY_FETCH_INVITES_ERROR_MESSAGE: 'There was a problem fetching invites',
  COMPANY_FETCH_TEAM_MEMBERS_ERROR_MESSAGE:
    'There was a problem fetching team members',
  COMPANY_FETCH_COMPANY_INFO_ERROR_MESSAGE:
    'There was a problem fetching the company info',
  CONFIRM_TEAM_MEMBER_REMOVAL_MESSAGE:
    'Are you sure you want to deactivate this user?',
  CONFIRM_INVITE_REMOVAL_MESSAGE:
    'Are you sure you want to remove this invite?',
  CLEAR_ALL_EMAILS: 'Clear All',
  ALL_LABELS: 'All Labels ({count})',
  NO_LABELS: 'No Labels to Display',
  LABELS_CREATE_ONE: 'Create one by adding in the form above.',
  LABELS_ERROR_FETCHING:
    'There was an error fetching labels, please try again.',
  LABEL_DELETE_CONFIRM:
    'Are you sure you want to delete “{labelName}” from the organization?',
  LABEL_DELETE: 'Delete Label',
  LABEL_DELETE_SUCCESS: 'Your label has been removed.',
  LABEL_DELETE_ERROR: 'There was a problem removing your label.',
  LABEL_EDIT: 'Edit Label',
  LABEL_EDIT_SUCCESS: 'Your label has been updated.',
  LABEL_EDIT_ERROR_DUPLICATE: 'There is already a label named {labelName}.',
  LABEL_EDIT_ERROR: 'There was a problem updating your label.',
  CUSTOM_FIELDS: 'Custom Fields',
  CUSTOM_FIELDS_DESCRIPTION:
    'View and manage custom fields your organization uses to identify your constituents.',
  CUSTOM_FIELDS_CREATE_NEW: 'Create New Field',
  CUSTOM_FIELDS_FIELD_NAME: 'Field Name',
  CUSTOM_FIELDS_FIELD_TYPE: 'Field Type',
  CUSTOM_FIELDS_MANDATORY: 'Mandatory',
  CUSTOM_FIELDS_CHECKBOX: 'Checkbox',
  CUSTOM_FIELDS_DATE_PICKER: 'Date Picker',
  CUSTOM_FIELDS_LIST: 'List',
  CUSTOM_FIELDS_TEXT_SINGLE: 'Text - Single Line',
  CUSTOM_FIELDS_TEXT_MULTIPLE: 'Text - Comment',
  CUSTOM_FIELDS_LIST_OPTIONS: 'List Options',
  CUSTOM_FIELDS_RESPONSE_TYPE: 'Response Type',
  CUSTOM_FIELDS_LIST_VALIDATION: 'Validation',
  CUSTOM_FIELDS_SINGLE_SELECT: 'Single Select',
  CUSTOM_FIELDS_MULTI_SELECT: 'Multi Select',
  CUSTOM_FIELDS_NO_ITEMS: 'No Items to Display',
  CUSTOM_FIELDS_CREATE_ONE: 'Create one by adding above.',
  CUSTOM_FIELDS_DELETE: 'Are you sure you want to delete this field?',
  CUSTOM_FIELDS_DELETE_FIELD: 'Delete Field',
  CUSTOM_FIELDS_CREATE_SUCCESS: 'Your custom field has been saved.',
  CUSTOM_FIELDS_CREATE_ERROR: 'There was a problem creating your custom field.',
  CUSTOM_FIELDS_NAME_COLLISION_ERROR:
    'There is already a custom field with that name.',
  CUSTOM_FIELDS_EDIT_SUCCESS: 'Your edit has been saved.',
  CUSTOM_FIELDS_EDIT_ERROR: 'There was a problem editing your custom field.',
  CUSTOM_FIELDS_DELETE_SUCCESS: 'Your custom field has been deleted.',
  CUSTOM_FIELDS_DELETE_ERROR: 'There was a problem deleting your custom field.',
  CUSTOM_FIELDS_OPTION_VALIDATION:
    'Commas are not allowed in custom field options.',
  AUTOMATIONS: 'Automations',
  AUTOMATIONS_DESCRIPTION:
    'Set up automated rules to assist in managing the recognition of major gifts.',
  AUTOMATIONS_NO_ITEMS: 'No Items to Display',
  AUTOMATIONS_CREATE_ONE: 'Create one by adding above.',
  AUTOMATIONS_CREATE_NEW: 'Create New Automation',
  AUTOMATIONS_TASK_SECTION: 'Tasks',
  AUTOMATIONS_LABEL_SECTION: 'Labels',
  AUTOMATIONS_DESCRIPTION_MIN_DONATION:
    '{taskTitle} when contribution is at least {minDonation}',
  AUTOMATIONS_DESCRIPTION_MAX_DONATION:
    '{taskTitle} when contribution is less than {maxDonation}',
  AUTOMATIONS_DESCRIPTION_RANGE:
    '{taskTitle} when contribution is between {minDonation} - {maxDonation}',
  AUTOMATIONS_ASSIGNED_TO: 'Assigned to @{displayName}',
  AUTOMATIONS_CREATE_LABEL: 'Create label',
  AUTOMATIONS_CONTRIBUTION_AMOUNT: 'When contribution amount is',
  AUTOMATIONS_CREATE_TASK: 'Create a task',
  AUTOMATIONS_APPLY_LABEL: 'Apply a label',
  AUTOMATIONS_DUE_DAY: 'Next day',
  AUTOMATIONS_DUE_WEEK: 'One week',
  AUTOMATIONS_DUE_MONTH: 'One month',
  AUTOMATIONS_TASK_HEADER: 'Task Information',
  AUTOMATIONS_LABEL_CONTRIBUTION: 'To the Contribution',
  AUTOMATIONS_LABEL_CONSTITUENT: 'To the Constituent',
  AUTOMATIONS_LABEL_HEADER: 'Apply Label',
  AUTOMATIONS_DELETE_CONFIRMATION:
    'Are you sure you want to delete this automation?',
};
